import { css } from "styled-components";

export const contentStyles = css`
    &.aevi-content-main {
        width: calc(100% - 270px);
        height: calc(100vh - 60px);
        overflow-x: hidden;
        overflow-y: auto;
        margin-top: 60px;
        margin-left: 270px;
        padding: 30px;
    }

    @media screen and (max-width: 960px) {
        &.aevi-content-main {
            margin-left: 50px;
            width: calc(100% - 50px);
        }
    }

    &.aevi-content-auth {
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow-x: hidden;
        overflow-y: auto;
        background-color: #f5f5f5;
    }

    @media screen and (max-width: 960px) {
        &.aevi-content-auth {
            width: 100%;
        }
    }
`;
